// src/admin/lib/buyLinkCounts.js
//
// "Live books with nowhere to buy them" (ticket 48), read in ONE place. The
// Affiliate Links screen and Overview's row both call this, and the number comes
// from the database function admin_buy_link_counts(), which applies the same rule
// the reader app does (isBookLink, src/lib/retailers.js). Counting link rows here
// would call a book buyable when readers see no Buy button, because the reader app
// drops a link that is not a page for the book itself.
//
// A count that could not be read comes back as null, which is not 0: "nothing
// wrong" and "could not tell" must never look the same.

import { supabase } from '../../lib/supabase';

const asCount = v => (v === null || v === undefined || Number.isNaN(Number(v)) ? null : Number(v));

export async function loadBuyLinkCounts(label = 'Affiliate') {
  const { data: rows, error } = await supabase.rpc('admin_buy_link_counts');
  const r = Array.isArray(rows) ? rows[0] : rows;
  if (error || !r) {
    console.error(`[${label}] buy-link counts failed:`, error?.message || 'no row came back');
    return null;
  }
  const counts = {
    live: asCount(r.live_books),
    nowhere: asCount(r.nowhere),
    noLink: asCount(r.no_link),
    rejected: asCount(r.link_rejected),
  };
  // A half-answer is not an answer: with any of the four missing, none is shown.
  return Object.values(counts).some(v => v === null) ? null : counts;
}
